import SupportIncidentsAPI from '../../api/supportIncidents';

// Store enxuto só pro badge da sidebar do Suporte (contagem de erros pendentes).
// A página /suporte continua falando com a API direto — aqui é só o contador.
const state = {
  pendingCount: 0,
};

export const getters = {
  getPendingCount: $state => $state.pendingCount,
};

export const actions = {
  fetchPendingCount: async ({ commit }) => {
    try {
      const { data } = await SupportIncidentsAPI.pendingCount();
      commit('SET_PENDING_COUNT', data.count || 0);
    } catch (error) {
      // badge é cosmético — quem não tem acesso toma 403; falha em silêncio.
    }
  },
};

export const mutations = {
  SET_PENDING_COUNT($state, count) {
    $state.pendingCount = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
